import * as React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Value = styled('div')(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  lineHeight: '100%',
  paddingRight: 8,
  fontVariantNumeric: 'tabular-nums',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  '&.good': {
    color: (theme.vars || theme).palette.success.main
  },
  '&.bad': {
    color: (theme.vars || theme).palette.error.main
  },
  '&.filled.good': {
    color: 'inherit',
    backgroundColor: theme.alpha((theme.vars || theme).palette.success.main, 0.3)
  },
  '&.filled.bad': {
    color: 'inherit',
    backgroundColor: theme.alpha((theme.vars || theme).palette.error.main, 0.3)
  }
}));
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
const TotalPrice = /*#__PURE__*/React.memo(function TotalPrice(props) {
  const {
    value,
    grouped
  } = props;
  return /*#__PURE__*/_jsx(Value, {
    className: clsx(value > 1000000 && "good", value < 1000000 && "bad", !grouped && "filled"),
    children: currencyFormatter.format(value)
  });
});
if (process.env.NODE_ENV !== "production") TotalPrice.displayName = "TotalPrice";
export function renderTotalPrice(params) {
  if (params.value == null) {
    return '';
  }

  // If the aggregated value does not have the same unit as the other cell
  // Then we fall back to the default rendering based on `valueGetter` instead of rendering the total price UI.
  if (params.aggregation && !params.aggregation.hasCellUnit) {
    return null;
  }
  return /*#__PURE__*/_jsx(TotalPrice, {
    value: params.value,
    grouped: params.rowNode.type === 'group'
  });
}